import { ResumeSummary } from '../../types/content';

/** PDF 2장 사이드바형 이력서 전용. 훑어 읽는 문서라 명사형 사실만 쓴다. 서사는 웹에 있다. */
export const resume: ResumeSummary = {
  keyFacts: ['백엔드 11년 → 데이터 플랫폼', '커머스 플랫폼 백엔드 5년 (2013~2018)', '웹툰 플랫폼 데이터 4년 (2022~)', '데이터인텔리전스팀 팀장 (2026.01~)'],
  headlines: [
    { title: 'DW 파이프라인을 처음부터 설계·구축', detail: '파이프라인이 없던 일본 픽코마에 수집(배치·실시간) → 5계층 가공 → API → 시각화까지. Airflow · Athena · Redshift' },
    { title: 'RFM 세그먼트 제품화 → 푸시 타겟팅', detail: '사용자 한 명 한 명을 세 축으로 정의·갱신하는 데이터 모델. 추출 요청이 같은 기준으로 고르는 일이 됨, 여러 조직으로 확산' },
    { title: 'AI 분석 보고서 하네스 단독 개발', detail: '작품·출판사·회사 KPI를 데이터 맵의 맥락과 연결. 6개월 개량, 여러 조직에서 권한 요청' },
    { title: '사내 시각화 플랫폼을 의사결정 플랫폼으로', detail: '요청 처리를 멈추고 현업 인터뷰로 구조를 재정의. 활성 사용자 2~3배, DW 데이터 맵으로 카탈로그까지' }
  ],
  detailNote: '대표 성과 7건과 아키텍처 다이어그램은 사이트에서'
};
